// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__3My14","deleteIcon":"Chip_deleteIcon__3KEZO"};